export type TranslationsFileLoader = {
  prefix: string[];
  loader: () => Promise<Matice.Translations>;
};

export async function loadTranslations(fileLoaders: TranslationsFileLoader[]) {
  const translations = {} as Matice.Translations;
  await Promise.all(
    fileLoaders.map(async ({ prefix, loader }) => {
      let root = translations;
      for (const part of prefix.slice(0, -1)) {
        root[part] = {};
        root = root[part];
      }
      root[prefix.at(-1)!] = await loader();
    }),
  );
  return translations;
}
